<template>
  <div class="tab-pane active" id="form-step-3">
    <div class="row">
      <template v-if="!showGBG">
        <div class="col-sm-12">
          <datetime-picker @goNext="goNextStep" />
        </div>
      </template>
       <template v-else>
    <Identity/>
    </template>
      <Loading v-if="loading" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mixin from "@/components/shared/mixinUtility";
import DateTimePicker from "@/components/ui/DateTimePicker.vue";
import Loading from "@/components/ui/Loading.vue";
import Identity from "@/components/steps/Identity.vue";
export default {
  name: "callback",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      showGBG: false,
    };
  },
  computed: {
    ...mapGetters({
      contactId: "getContactId",
      additionalContactId: "getAdditionalContactId",
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      formData: "getFormData",
      mainContactId: "getMainContactId",
      mainGBGStatus: "getMainUserGBGStatus",
      additionalGBGStatus: "getAdditionalUserGBGStatus",
    }),
  },
  components: {
    Loading,
    "datetime-picker": DateTimePicker,
     Identity
  },
  watch: {
    async mainGBGStatus() {
      if (this.mainGBGStatus != "") {
        console.log("watch");
        //call status API or just pass status
        let mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );
        //check if user is already verified
        if (mainRes.alreadyVerified) {
          if (this.additionalContactId == null) this.goNextStep();
          else if (
            //check additional user status
            this.additionalContactId != null &&
            this.additionalGBGStatus != ""
          ) {
            //already rendered identity component for additional user?
            const addUserRes = await this.setIdentityClient(
              this.additionalContactId,
              this.additionalGBGStatus,
              false
            );
            if (mainRes.alreadyVerified && addUserRes.alreadyVerified)
              this.goNextStep();
          }
        }
         this.loading = false;
      }
    },
    async additionalGBGStatus() {
      if (this.additionalGBGStatus != "") {
        console.log("watch2");
        //call status API or just pass status
        let addUserRes = await this.setIdentityClient(
          this.additionalContactId,
          this.additionalGBGStatus,
          false
        );
        //check if user is already verified
        if (addUserRes.alreadyVerified) {
          if (this.mainGBGStatus != "") {
            console.log("watch");
            //call status API or just pass status
            let mainRes = await this.setIdentityClient(
              this.contactId,
              this.mainGBGStatus,
              true
            );

            if (mainRes.alreadyVerified) this.goNextStep();
          }
        }
         this.loading = false;
      }
    },
  },
  methods: {
    goNextStep() {
      console.log("next");
      this.resetMessageInfo();
      this.loading = false;
      this.showGBG = true;
    },
    async setIdentityClient(currContactId, status) {
      //init user documentation object
      let result = {
        contactId: currContactId,
        alreadyVerified: false,
      };

      if (status == "verified" || status == "invalid")
        result.alreadyVerified = true;

      return result;
    },
  },
  async created() {
    this.resetMessageInfo();
    this.$store.dispatch("setHideNavigation", true);

    if (
      this.mainGBGStatus == "" ||
      (this.additionalContactId != null && this.additionalGBGStatus == "")
    )
      //gbg still loading
      this.loading = true;
    else {
      //already got response from GBG
      let mainRes = null;
      if (this.contactId != null) {
        mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );

        //check if user is already verified
        if (mainRes.alreadyVerified && this.additionalContactId == null)
          this.goNextStep();
      }
      //additional user
      if (this.additionalContactId != null && this.additionalGBGStatus != "") {
        const addUserRes = await this.setIdentityClient(
          this.additionalContactId,
          this.additionalGBGStatus,
          false
        );
        //check if user is already verified
        if (mainRes.alreadyVerified && addUserRes.alreadyVerified)
          this.goNextStep();
      }
    }
  },
};
</script>
